import { AuthLayout } from "@/components/auth/AuthLayout";
import { ForgotPasswordForm } from "@/components/auth/ForgotPasswordForm";
import { usePageTitle } from "../hooks/usePageTitle";

export function ForgotPasswordPage() {
  usePageTitle("Forgot password | TidyRota");

  return (
    <AuthLayout>
      <ForgotPasswordForm />
    </AuthLayout>
  );
}
